module.exports = __webpack_public_path__ + "3f9cb3731d9e81d0f43875bd4dbb78fd.png";


//////////////////
// WEBPACK FOOTER
// ./directives/appCard/jcb.png
// module id = 962
// module chunks = 0